import { PaymentMethodToken, VaultListItem } from '../types';
import { PaymentInstrumentType } from '../enums/Tokens';
import { Icons } from '../assets/icons/Icons';

export function formatVaultedToken(
  token: PaymentMethodToken,
): Nullable<VaultListItem> {
  switch (token.paymentInstrumentType) {
    case PaymentInstrumentType.CARD:
      return {
        id: token.token,
        type: PaymentInstrumentType.CARD,
        details: {
          last4Digits: token.paymentInstrumentData.last4Digits,
          cardNumber: `●●●● ${token.paymentInstrumentData.last4Digits}`,
          name: token.paymentInstrumentData.cardholderName,
          icon: iconFromNetwork(token.paymentInstrumentData.network),
          network: token.paymentInstrumentData.network,
        },
      };

    case PaymentInstrumentType.PAYPAL_VAULTED:
      return {
        id: token.token,
        type: PaymentInstrumentType.PAYPAL_VAULTED,
        details: {
          icon: Icons.paypal,
          email: token.paymentInstrumentData.externalPayerInfo?.email,
        },
      };

    default:
      return null;
  }
}

function iconFromNetwork(network = ''): string {
  const lower = network.toLowerCase();
  const icon = Icons[lower];
  return icon || Icons.genericCard;
}
